import { AnalyticEvent } from '..'

export enum AuthenticationAnalytic {
    Login = 'login',
    Logout = 'logout',
}

export class AuthenticationAnalyticHelper {
    static getName(analytic: AuthenticationAnalytic): string {
        return analytic
    }

    static getProperties(
        analytic: AuthenticationAnalytic
    ): Record<string, string> {
        switch (analytic) {
            default:
                return { type: 'authentication' }
        }
    }

    static getMetric(analytic: AuthenticationAnalytic): Record<string, number> {
        switch (analytic) {
            default:
                return {}
        }
    }

    static makeEvent(analytic: AuthenticationAnalytic): AnalyticEvent {
        return {
            name: this.getName(analytic),
            attributes: this.getProperties(analytic),
            metric: this.getMetric(analytic),
        }
    }
}
